// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__EkwzB","title":"ClientInsurance_title__2hb0X","itemText":"ClientInsurance_itemText__20ekW"};